 /**
 * @author Pawan Sadvale
 * @email Pawan.Sadvale@ul.com
 * @create date 2019-12-10 11:09:38
 * @modify date 2019-12-10 11:09:38
 * @desc Modal pop for admin interface
 */
<template>
  <div>
    <div  :id="'list'+propId" class="modal fade custom modal-open" role="dialog">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title"> Headlines List
            </h4>
          </div>
          <div class="modal-body headline-modal">
            <div>
             <table class="table headlines-table" v-if="headlines.length">
              <thead>
                <tr>
                  <th class="admin-col">
                    <div class="checkbox">
                      <label>
                        <input type="checkbox"
                          :checked="selectedAll"
                          @input="selectedAll = $event.target.checked"
                          @change="checkList('all')"
                        />
                        <span class="cr">
                        </span>
                      </label>
                    </div>
                  </th>
                  <th class="first-col"></th>
                  <th class="w-50 w-48">Headline</th>
                  <th class="w-3"></th>
                  <th width="18%" class="pl-0">Headline Type</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(record, index) in headlines" :key="index">
                  <td class="admin-col">
                    <div class="checkbox">
                      <label>
                        <input type="checkbox"
                          v-model="selectedItems"
                          :value="record.id"
                          @change="checkList()"
                        />
                        <span class="cr">
                        </span>
                      </label>
                    </div>
                  </td>
                  <td class="first-col">
                    <div class="tableUpdateIcons">
                      <span
                        class="glyphicon glyphicon-pencil cursor-pointer edit_color" @click="handleRecord(record)"
                      ></span>
                    </div>
                  </td>
                  <td class="w-50">{{ record.title }}</td>
                  <td class="w-3"></td>
                  <td class="w-18">
                    {{operations.type}}
                  </td>
                  <td v-if="operations.type === 'Main Headline'">
                  {{record.display_date | dateFormat}}
                  </td>
                  <td v-if="operations.type === 'Featured Content'">
                  {{record.start_date | dateFormat}} to {{record.end_date | dateFormat}}
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
            <loader :loadingStatus="loaderStatus"></loader>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-modal-footer cancel cancel_button fl-lt"
              @click="closeListPopUp"
            >
              <i class="fa fa-times-circle"></i> Cancel
            </button>
            <button
              type="button"
              class="btn btn-modal-footer submit_button fl-rt delete-btn"
              :disabled="disablePublishChanges || !selectedItems.length"
              v-on:click="openDeletePopup()">
              <img src="/static/images/icons/delete_icon.svg" class="reg-headline-delete" alt="delete-icon" /> {{publishBtnTxt}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>

<script>
import moment from 'moment';
import Loader from '../UIComponents/Loader.vue';
import {
  getAllFeaturedContent,
  getMainHeadlines,
} from '../../apis/dashboard';

export default {
  props: ['propId', 'operations'],
  data() {
    return {
      loaderStatus: false,
      headlines: [],
      click: false,
      selectedItems: [],
      selectedAll: false,
      publishBtnTxt: 'Delete',
      disablePublishChanges: false,
      listRegHeadlineProp: 'listRegHeadlineProp headline',
      listRegHeadlineLoaderStatus: false,
    };
  },

  components: {
    Loader,
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },

    closeListPopUp() {
      this.selectedItems = [];
      this.selectedAll = false;
      this.$emit('closeList');
    },
    /**
     * handleRecord() is for to send the edit object to the edit popup wizard
     */
    handleRecord(record) {
      const newRecord = record;
      newRecord.type = this.operations.type;
      this.$emit('onOpenEditPopup', record);
    },
    /**
     * checkList() is for to handle the no.of records the user is selected for deletion
     */
    checkList(type) {
      if (type === 'all') {
        if (this.selectedAll) {
          this.selectedItems = this.headlines.map((headline) => headline.id);
        } else this.selectedItems = [];
      } else if (this.headlines.length === this.selectedItems.length) {
        this.selectedAll = true;
      } else {
        this.selectedAll = false;
      }
    },
    openDeletePopup() {
      if (this.operations.type === 'Featured Content') {
        this.$emit('openModalDelete', 'featured content');
      } else if (this.operations.type === 'Main Headline') {
        this.$emit('openModalDelete', 'headline');
      }
    },

    async intialAPIs(type) {
      try {
        if (this.operations.action_type === 'Edit') {
          this.loaderStatus = true;
          if (type === 'Featured Content') {
            const headlines = await getAllFeaturedContent();
            this.headlines = headlines.data;
          } else if (type === 'Main Headline') {
            const headlines = await getMainHeadlines();
            this.headlines = headlines.data;
          }
          this.loaderStatus = false;
        }
      } catch (err) {
        this.loaderStatus = false;
      }
    },
  },
  filters: {
    dateFormat(date) {
      return moment(date).format('Do MMM YYYY');
    },
  },
  watch: {
    operations(newVal) {
      this.headlines = [];
      this.selectedItems = [];
      this.selectedAll = false;
      this.intialAPIs(newVal.type);
    },
    selectedItems: {
      handler() {
        this.$emit('selectedHeadLinesList', this.selectedItems);
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.w-3 {
  width: 3%;
}
.w-18 {
  width: 18%;
}

.modal-open {
  z-index: 100;
}
.table.headlines-table > thead {
  border-top: none;
}
.headline-modal {
  padding-top: 0px;
}
.pd-lt-0 {
  padding-left: 0;
}
.txt-rt {
  text-align: right;
}
.fl-rt {
  float: right;
}
.fl-lt {
  float: left;
}
.pd-tp-20 {
  padding-top: 20px;
}
.pd-bt-20 {
  padding-bottom: 20px;
}
textarea {
  resize: none;
}
.mandatory {
  color: red;
}
.row-wrapper {
  margin-top: 10px;
  margin-bottom: 10px;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.edit_color {
  color: #0b3c61;
}
.headlines-table {
  vertical-align: unset;
}
.headlines-table tr:hover > td {
  background-color: #fff;
}
.headlines-table tr > td {
  font-size: 14px;
  border-bottom: 1px solid #ebeef5;
  color: #606266;
  padding: 12px 0 !important;
}
.headlines-table td a {
  color: #0b3c61;
}
.headlines-table th {
  font-weight: 500;
  font-size: 14px;
  color: #0b3c61;
  padding: 12px 0 !important;
  border-bottom: 1px dashed #ebeef5 !important;
}
.headlines-table thead {
  background: #fff;
}
.headlines-table.table > thead:first-child > tr:first-child > th {
  font-weight: 500;
}
.headlines-table .cell {
  word-break: break-word;
}
.first-col {
  width: 5%;
}
.admin-col {
  width: 3%;
}
.admin-col + .first-col {
  width: 3%;
}

.admin-col ~ .w-50 {
  width: 50%;
}
.admin-col .tableUpdateIcons {
  text-align: center;
}
.admin-col .tableUpdateIcons span {
  padding: 0 5px;
  font-size: 16px;
}
.delete-btn {
  color: #0b3c61 !important;
  border-color: #0b3c61;
  font-weight: 700;
  background: transparent;
}
.modal-body {
  min-height: 250px;
}
@media only screen and (max-width: 991px) {
  .txt-rt {
    text-align: left;
  }
  ::v-deep .date-field .el-input__prefix {
    left: 0px;
  }
}

table tbody {
  display: block;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}

table thead, table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

@media screen and (max-width: 500px){
  .admin-col, .admin-col + .first-col{
    width: 6%;
  }
}
</style>
